// AppWrapper.js
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { refreshTokenData } from "./slices/signIn.slice";
import { getLocalStorage } from "./helpers/utils";

const AppWrapper = ({ children }) => {
  const dispatch = useDispatch();

  const { collapsed } = useSelector((state) => state.sidebar);
  useEffect(() => {
    const timeout = setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 300); // resize graphs when collapse changes

    return () => clearTimeout(timeout);
  }, [collapsed]);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentAuth = getLocalStorage("AUTH_DETAILS");
      if (currentAuth && currentAuth.refresh) {
        dispatch(refreshTokenData({ refresh: currentAuth.refresh }));
      }
    }, 4 * 60 * 1000); // every 4 minutes

    return () => clearInterval(interval);
  }, []);

  return children;
};

export default AppWrapper;
